import { Component, Input } from '@angular/core';
import { CurrentTenantService } from '@suvo-bi-users';
import { IContactsTileInstance } from '../../../../interfaces/tiles/definitions/contacts-tile-definition.interface';
import {
  resolveSiteAssetCssValue,
  resolveSiteAssetUrl,
} from '../../../../utils/resolve-site-asset-url.util';

@Component({
  standalone: false,
  selector: 'suvo-bi-contacts-tile',
  templateUrl: './contacts-tile.component.html',
  styleUrls: ['./contacts-tile.component.scss'],
})
export class ContactsTileComponent {
  @Input() tileInstance: IContactsTileInstance;

  constructor(private readonly tenantService: CurrentTenantService) {}

  private get siteBaseUrl(): string {
    return this.tenantService.currentTenantData?.primaryWebUrl ?? '';
  }

  get backgroundStyle(): string {
    return resolveSiteAssetCssValue(this.tileInstance?.background ?? '', this.siteBaseUrl);
  }

  getContactImgPath(path: string): string {
    return resolveSiteAssetUrl(path, this.siteBaseUrl);
  }
}
